var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Collapse from '@material-ui/core/Collapse';
import clsx from 'clsx';
import StationInfo from './StationInfo';
var StationListItem = function (_a) {
    var station = _a.station, selected = _a.selected, onClick = _a.onClick, onTopClick = _a.onTopClick, fullStation = _a.fullStation, isOpen = _a.isOpen, children = _a.children;
    return (_jsxs("div", __assign({ onClick: function (e) { return onClick(e, station); }, className: clsx('station-card', selected && 'selected-station-card') }, { children: [_jsxs("div", __assign({ className: 'flex', onClick: onTopClick }, { children: [_jsxs("div", { children: [_jsx("div", __assign({ className: 'card-title' }, { children: station.stationName }), void 0),
                            _jsx("div", __assign({ className: 'sub-title' }, { children: station.address }), void 0)] }, void 0),
                    selected && (_jsx("img", { className: 'arrow', src: '/lulav-icons/expand-accordion-arrow.svg', style: isOpen ? { transform: 'rotate(180deg)' } : {} }, void 0))] }), void 0),
            selected && (_jsx(Collapse, __assign({ "in": isOpen, timeout: "auto", unmountOnExit: true }, { children: _jsx(StationInfo, __assign({ station: fullStation }, { children: children }), void 0) }), void 0))] }), void 0));
};
export default StationListItem;
//# sourceMappingURL=StationListItem.js.map